module.exports = __webpack_public_path__ + "../resources/img/ic_module_panel_default.4dd8417b.svg";